import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import AnalyticsClick from '~/components/Shared/Analytics/AnalyticsClick';
import Image from '~/components/Shared/Image/Image';
import type { AuthorCardBlockInterface } from '~/types/AppData/PageBuilder/AuthorCardBlockInterface';
import { getImagePathAndExtension } from '~/utilities/getImagePathAndExtension';
import { getOneIndexing } from '~/utilities/getOneIndexing';
import AnalyticsContainer from '~/components/Shared/Analytics/AnalyticsContainer';

export default component$<
  AuthorCardBlockInterface['props'] & { index: number }
>(({ authorName, quote, imageUrl, alt, link, index }): JSX.Element => {
  const { path, extension } = getImagePathAndExtension(imageUrl);

  const componentName = `AuthorCard-${getOneIndexing(index)}`;

  return (
    <AnalyticsContainer
      component_name={componentName}
      component_type='AuthorCard'
      component_placement={getOneIndexing(index)}
    >
      <AnalyticsClick
        click_link_url={link}
        link_position={getOneIndexing(index)}
      >
        <a
          href={link}
          class='w-full flex flex-row md:flex-col items-start md:items-center p-2.5 gap-2.5 md:gap-1 group/author'
        >
          {path ? (
            <Image
              aspectRatio={'1/1'}
              imageWidths={{ small: 80, medium: 80, large: 86 }}
              alt={alt}
              loading='lazy'
              imageClass='rounded-full'
              wrapperClass='!bg-[transparent]'
              path={path}
              fileExtension={extension}
            />
          ) : (
            <div class='w-20 h-20 rounded-full bg-lightGrey' />
          )}

          <div class='font-group-big flex flex-col flex-1 items-start md:items-center text-left md:text-center gap-1.5'>
            <span class='block relative'>
              <span class='font-bold group-hover/author:text-primary'>
                {authorName}
              </span>
              <span class='absolute left-0 bottom-0 w-full h-[3px] bg-primary'></span>
            </span>

            <span class='font-medium italic'>"{quote}"</span>
          </div>
        </a>
      </AnalyticsClick>
    </AnalyticsContainer>
  );
});
